import { useTranslation } from "react-i18next";

export function ImportFileMetadata({
  fileName,
  rowCount,
}: {
  fileName: string | null;
  rowCount: number;
}): React.JSX.Element | null {
  const { t, i18n } = useTranslation();
  if (!fileName) return null;

  return (
    <div className="grid min-w-0 justify-items-start gap-0.5 text-start" data-testid="contact-import-file-meta">
      <p className="m-0 flex min-w-0 max-w-full items-baseline gap-2 text-[0.8125rem]">
        <span className="shrink-0 text-[0.6875rem] font-medium text-muted">
          {t("contacts.import.fileLabel")}
        </span>
        <bdi className="min-w-0 truncate [unicode-bidi:isolate]" dir="auto" title={fileName}>
          {fileName}
        </bdi>
      </p>
      <p className="m-0 text-start text-[0.75rem] text-muted">
        {t("contacts.import.rowsLabel")}{" "}
        <span className="tabular-nums text-foreground">{rowCount.toLocaleString(i18n.language)}</span>
      </p>
    </div>
  );
}
